import React from 'react';

const Contact = () => {
  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-12">
          <h1 className="display-5 fw-bold mb-5 text-center">
            <i className="bi bi-geo-alt me-3 text-primary"></i>
            İletişim
          </h1>
        </div>
      </div>

      <div className="row">
        {/* Harita Bölümü - Sol Taraf */}
        <div className="col-lg-8 mb-4 mb-lg-0">
          <div className="card h-100">
            <div className="card-body p-0">
              <div className="map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3127.4285136119115!2d27.168626200000002!3d38.38534!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbd8ab5b457f31%3A0xe110989625898322!2zScWeSUxUSSBTQVogRVbEsA!5e0!3m2!1str!2str!4v1756673624343!5m2!1str!2str"
                  width="100%"
                  height="500"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="İsilti Saz Evi Konum"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* İletişim Bilgileri - Sağ Taraf */}
        <div className="col-lg-4">
          <div className="card h-100">
            <div className="card-body p-4">
              <h3 className="h5 mb-4 text-center">
                <i className="bi bi-info-circle me-2 text-primary"></i>
                İletişim Bilgileri
              </h3>
              
              <div className="contact-info-item mb-4">
                <div className="d-flex align-items-start mb-2">
                  <div className="contact-icon">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div>
                    <strong className="d-block mb-1">Adresimiz</strong>
                    <p className="text-muted mb-0 small">
                    Çevik Bir Meydanı <br/>
                    /127 Sok. No:18/A,<br/>
                    İzmir, Turkey 35380<br/>
                      
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="contact-info-item mb-4">
                <div className="d-flex align-items-start mb-2">
                  <div className="contact-icon">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div>
                    <strong className="d-block mb-1">Telefon</strong>
                    <p className="text-muted mb-1 small">
                      <a href="tel:+905356091300" className="text-decoration-none text-muted">
                        +90 535 609 13 00
                      </a>
                    </p>
                    
                  </div>
                </div>
              </div>
              
              <div className="contact-info-item mb-4">
                <div className="d-flex align-items-start mb-2">
                  <div className="contact-icon">
                    <i className="bi bi-envelope"></i>
                  </div>
                  <div>
                    <strong className="d-block mb-1">E-posta</strong>
                    <p className="text-muted mb-1 small">
                      <a href="mailto:info@isiltisazevi.com" className="text-decoration-none text-muted">
                        info@isiltisazevi.com
                      </a>
                    </p>
                    <p className="text-muted mb-0 small">
                      <a href="mailto:siparis@isiltisazevi.com" className="text-decoration-none text-muted">
                        siparis@isiltisazevi.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="contact-info-item mb-4">
                <div className="d-flex align-items-start mb-2">
                  <div className="contact-icon">
                    <i className="bi bi-clock"></i>
                  </div>
                  <div>
                    <strong className="d-block mb-1">Çalışma Saatleri</strong>
                    <p className="text-muted mb-1 small">
                      <strong>Hafta İçi:</strong> 09:00 - 18:00
                    </p>
                    <p className="text-muted mb-1 small">
                      <strong>Cumartesi:</strong> 09:00 - 18:00
                    </p>
                    <p className="text-muted mb-0 small">
                      <strong>Pazar:</strong> İletişime geçebilirsiniz
                    </p>
                  </div>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="d-flex align-items-start mb-2">
                  <div className="contact-icon">
                    <i className="bi bi-share"></i>
                  </div>
                  <div className="w-100">
                    <strong className="d-block mb-3">Sosyal Medya</strong>
                    <div className="d-flex gap-3 flex-wrap">
                      <a 
                        href="https://www.facebook.com/is.lt.saz.evi/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="social-link facebook"
                        title="Facebook"
                      >
                        <i className="bi bi-facebook"></i>
                      </a>
                      <a 
                        href="https://instagram.com/isiltisazevi" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="social-link instagram"
                        title="Instagram"
                      >
                        <i className="bi bi-instagram"></i>
                      </a>

                      <a 
                        href="https://wa.me/905356091300" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="social-link whatsapp"
                        title="WhatsApp"
                      >
                        <i className="bi bi-whatsapp"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
